import { ServiceTypes } from 'constants/ServiceTypes';
import { PitchingProgressState } from 'enums/PitchingProgressState';
import { IPitchBounceValidationDecision } from 'interfaces/tagging/ApiModels/IPitchBounceValidationDecision';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { BroadcastConsumerService } from 'services/data-services/BroadcastConsumerService';
import { useInjection } from 'services/ioc/ioc.react';
import { FieldCalibrationStore, MAX_CALIBRATION_COUNT_NUMBER, MAX_HOME_PLATE_COUNT_NUMBER } from 'stores/FieldCalibrationStore';
import PitchingProgressImage from './PitchingProgressImage';
import ProgressBarContainer from './ProgressBarContainer';
import { StyledSection } from './styles/PitchingProgressStyles';

const PitchingProgress: React.FC = observer(() => {
  const fieldCalibrationStore = useInjection<FieldCalibrationStore>(ServiceTypes.FieldCalibrationStore);
  const broadcastService = useInjection<BroadcastConsumerService>(ServiceTypes.BroadcastConsumerService);

  const timeoutFunction = (): void => {
    setTimeout(() => fieldCalibrationStore.setPitchingProgressState(PitchingProgressState.WaitingForAPitch), 3000);
  };

  const onPitchCalibrationDecisionReceived = (pitchCalibrationDecision: IPitchBounceValidationDecision): void => {
    if (pitchCalibrationDecision.calibration.bounceWithin5FeetFromHP) {
      fieldCalibrationStore.incrementValidCount();
    }

    if (pitchCalibrationDecision.calibration.hitHP) {
      fieldCalibrationStore.incrementInvalidCount();
    }

    fieldCalibrationStore.setBreaksTracked(pitchCalibrationDecision.calibration.breaks);
    fieldCalibrationStore.incrementTotalCount();

    timeoutFunction();
  };

  useEffect(() => {
    broadcastService.subscribePitchBounceValidationDecision(onPitchCalibrationDecisionReceived);
    return (): void => {
      broadcastService.unsubscribePitchBounceValidationDecision();
    };
  }, []);

  useEffect(() => {
    if (
      fieldCalibrationStore.bounceWithin5FeetFromHPCount >= MAX_CALIBRATION_COUNT_NUMBER ||
      fieldCalibrationStore.hitHPCount >= MAX_HOME_PLATE_COUNT_NUMBER
    ) {
      fieldCalibrationStore.setPitchingProgressState(PitchingProgressState.EnoughPitches);
      broadcastService.unsubscribePitchBounceValidationDecision();
    }
  }, [fieldCalibrationStore.totalCount]);

  return (
    <StyledSection>
      <PitchingProgressImage />
      <ProgressBarContainer />
    </StyledSection>
  );
});

export default PitchingProgress;
